// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__153Zd","label":"styles_label__1Fb9J"};